import Base from './base'
import urls from 'config/urls'

class User extends Base {
  login (opts) {
    return this.httpPost({
      url: urls.user.login,
      data: opts
    })
  }

  loginStatus (opts) {
    return this.httpGet({
      url: urls.user.loginStatus,
      data: opts
    })
  }

  logout (opts) {
    return this.httpPost({
      url: urls.user.logout,
      data: opts
    })
  }

  find (opts) {
    return this.httpGet({
      url: urls.user.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.user.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.user.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.user.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.user.delete,
      data: opts
    })
  }

  activate (opts) {
    return this.httpPost({
      url: urls.user.activate,
      data: opts
    })
  }

  changePassword (opts) {
    return this.httpPost({
      url: urls.user.changePassword,
      data: opts
    })
  }

  resetPassword (opts) {
    return this.httpPost({
      url: urls.user.resetPassword,
      data: opts
    })
  }
}

export default new User



// WEBPACK FOOTER //
// ./src/models/user.js